import React from "react";
import {ASSETS_BASE_URL} from "./constants";

export function Card(props) {
    const truncate = (str) => {
        return str.length > 150 ? str.substring(0, 147) + "..." : str;
    }

    const openModal = () => {
        props.setOpen(props.offer.id)
    }

    return (
        <div className="relative h-full flex-1 flex flex-col items-center p-4 sm:p-8">
            <img loading="lazy" className=" absolute top-0 z-0 w-full h-64 rounded-lg object-cover"
                 src={ASSETS_BASE_URL + 'xxhdpi/' + props.offer.image}
                 alt={props.offer.company.name}/>
            <div
                className="shadow mt-36 z-10 p-4 bg-white w-full rounded-lg flex flex-col border-b-4 border-red-600 flex-1">
                <img loading="lazy" className=" w-32 my-4 h-auto flex-shrink-0 mx-auto object-cover"
                     src={ASSETS_BASE_URL + 'xhdpi/' + props.offer.company.logo}
                     alt={props.offer.company.name + '-logo'}/>
                <h3 className="text-gray-900 text-xl md:text-3xl text-center font-bold">{props.offer.company.name}</h3>
                <div className="my-4 flex-grow flex flex-col px-4 justify-between">
                    <span className="text-gray-500 text-base md:text-lg"
                          dangerouslySetInnerHTML={{__html: truncate(props.offer.description)}}></span>
                </div>
                {/*'/' + props.offer.companyId*/}
                <button onClick={openModal}
                        className="block w-full text-center rounded-lg mb-4 border border-gray-400 px-5 py-3 transition-colors ease-in-out duration-200 bg-white text-base font-medium text-gray-900 shadow hover:bg-red-600 hover:text-white focus:outline-none focus:ring-2 focus:ring-offset-2 sm:px-10">

                    Angebotdetails
                </button>
            </div>
        </div>

    )
}
